import type { ContentBuilder } from '../../ui/ContentBuilder';
import type { SettlementView } from '../utils';
import { getTreeTotal, getWildlifeTotal } from '../utils';
import type { HexMapState } from '../../../engine/render/renderer';
import { t } from '../../../i18n/translations';

export function renderNatureTab(
    builder: ContentBuilder,
    state: HexMapState,
    settlement: SettlementView,
): void {
    const lang = state.config.ui.language;
    builder.section(t(lang, 'nature.section'), (section) => {
        section.text(t(lang, 'region.trees', getTreeTotal(settlement)));
        section.text(t(lang, 'region.wildlife', getWildlifeTotal(settlement)));
        section.text(t(lang, 'region.fish', settlement.regionResources.fish));
        section.text(t(lang, 'region.stone', settlement.regionResources.stone));
        section.text(t(lang, 'region.gold', settlement.regionResources.gold));
        section.text(t(lang, 'region.stoneDeposit', settlement.regionResources.stoneDeposit));
        section.text(t(lang, 'region.ironDeposit', settlement.regionResources.ironDeposit));
        section.text(t(lang, 'region.goldDeposit', settlement.regionResources.goldDeposit));
    });
}
